const firebaseAuthErrors: Record<string, string> = {
    'auth/invalid-credential': 'Las credenciales proporcionadas no son válidas.',
    'auth/email-already-in-use': 'El correo electrónico ya está en uso.',
    'auth/user-not-found': 'No se encontró un usuario con este correo.',
    'auth/wrong-password': 'La contraseña es incorrecta.',
    'auth/too-many-requests': 'Demasiados intentos. Intenta más tarde.',
    'auth/network-request-failed': 'Error de conexión. Verifica tu internet.',
    'auth/weak-password': 'La contraseña es demasiado débil.',
    'auth/missing-email': 'El campo de correo electrónico está vacío.',
    'auth/invalid-email': 'El correo electrónico no es válido.',
    'auth/requires-recent-login': 'Por seguridad, vuelve a iniciar sesión y repite la acción.',
    'auth/operation-not-allowed': 'Esta operación no está permitida.',
    'auth/account-exists-with-different-credential': 'Este correo está registrado con otro método de autenticación.'
};

export const translateFirebaseError = (errorCode: string): string => {
    return firebaseAuthErrors[errorCode] || 'Ocurrió un error desconocido.';
};
